import * as React from "react";

import { FancyDropdownIconModePrompt } from "./FancyDropdownIconModePrompt";
import { IFancyDropdownOptionProps } from "./FancyDropdownOption";
import { FancyDropdownOptions } from "./FancyDropdownOptions";
import { FancyDropdownTextModePrompt } from "./FancyDropdownTextModePrompt";

export enum FancyDropdownMode {
  textButton,
  iconButton,
}

export enum FancyDropdownAlignment {
  left,
  right,
}

export interface IFancyDropdownProps {
  itemID?: string;
  alignment?: FancyDropdownAlignment;
  defaultText: string;
  fontAwesomeIcon?: string;
  mode: FancyDropdownMode;
  options: IFancyDropdownOptionProps[];
  selectedValue?: string;
  optionalClassName?: string;
  tabIndex?: number;
  toolTip?: string;
  onFocussed?: (itemID: string) => void;
}

const getVerifiedOptions = (options: IFancyDropdownOptionProps[], selectedValue: string): IFancyDropdownOptionProps[] => {
  // Enforce that only option equal to selected value is marked as selected.
  const verifiedOptions: IFancyDropdownOptionProps[] = Object.assign([], options);
  verifiedOptions.map((option, i) => {
    option.isSelected = option.value === selectedValue;
    return option;
  });
  return verifiedOptions;
};

const getTextAboveDropdown = (selectedValue: string, options: IFancyDropdownOptionProps[], defaultText: string, mode: FancyDropdownMode): string => {
  let textAboveDropdown = "";
  if (mode === FancyDropdownMode.textButton) {
    if (selectedValue !== "") {
      const checkOptions: IFancyDropdownOptionProps[] = Object.assign([], options);
      const matchedOptions = checkOptions.filter((option) => option.value.toUpperCase() === selectedValue.toUpperCase());
      if (matchedOptions && matchedOptions.length === 1) {
        textAboveDropdown = matchedOptions[0].text;
      } else {
        textAboveDropdown = "Not Found";
      }
    } else {
      textAboveDropdown = defaultText;
    }
  }
  return textAboveDropdown;
};

export const FancyDropdown = (props: IFancyDropdownProps) => {

  const itemID = props.itemID === undefined ? "" : props.itemID;
  const selectedValue = props.selectedValue === undefined ? "" : props.selectedValue;
  const verifiedOptions = getVerifiedOptions(props.options, selectedValue);
  const textAboveDropdown = getTextAboveDropdown(selectedValue, props.options, props.defaultText, props.mode);

  return (
    <React.Fragment>

      {props.mode === FancyDropdownMode.textButton &&
        <FancyDropdownTextModePrompt itemID={itemID} numOptions={verifiedOptions.length} text={textAboveDropdown} tabIndex={props.tabIndex} toolTip={props.toolTip} onFocussed={props.onFocussed}/>
      }

      {props.mode === FancyDropdownMode.iconButton &&
        <FancyDropdownIconModePrompt itemID={itemID} text={props.defaultText} fontAwesomeIcon={props.fontAwesomeIcon} tabIndex={props.tabIndex} onFocussed={props.onFocussed}/>
      }

      <FancyDropdownOptions itemID={itemID} options={verifiedOptions} alignment={props.alignment} optionalClassName={props.optionalClassName} />

    </React.Fragment>
  );

};
